import React from 'react'
import styled from 'styled-components'
import { Scalars } from 'types/graphql'
import { media } from 'utils/media'
import { useReturnToPath } from 'utils/useReturnToPath'
import { LinkButton as OriginalLink, Button as OriginalButton } from 'lib/Button/Button'
import { useAuthentication } from 'modules/auth/useAuthentication'
import { useCurrentUser } from 'modules/auth/useCurrentUser'

const LinkButton = styled(OriginalLink)`
  white-space: nowrap;
  ${media.phoneDown} {
    display: flex;
  }
`

const Button = styled(OriginalButton)`
  white-space: nowrap;
  ${media.phoneDown} {
    display: flex;
  }
`

interface Props {
  brandId: Scalars['ID']
  brandTitle: string
  brandSlug: string
  className?: string
  reviewId?: Scalars['ID']
}

interface WriteOrEditButtonProps {
  brandSlug: string
  className?: string
  onWriteClick: () => void
  reviewId?: Scalars['ID']
}

const WriteOrEditButton = ({ reviewId, brandSlug, onWriteClick, className }: WriteOrEditButtonProps) => {
  return reviewId ? (
    <LinkButton className={className} href={`/brands/${brandSlug}/reviews/${reviewId}/edit`} color="secondary">
      Edit review
    </LinkButton>
  ) : (
    <LinkButton className={className} href={`/brands/${brandSlug}/review`} onClick={onWriteClick} color="primary">
      Write a review
    </LinkButton>
  )
}

export const WriteOrEditReviewButton = ({ brandId, brandTitle, brandSlug, className, reviewId }: Props) => {
  const { user } = useCurrentUser()
  const { authenticationService } = useAuthentication()
  const { setReturnToPath, returnToOrRedirect } = useReturnToPath()

  const trackReviewClick = () => {
    if (user) {
      window.analytics.track('Signed-in Write Review Click', {
        brandId,
        properties: { label: brandTitle }
      })
    } else {
      window.analytics.track('Anonymous Write Review Click', {
        brandId,
        properties: { label: brandTitle }
      })
    }
  }

  if (user) {
    return <WriteOrEditButton className={className} brandSlug={brandSlug} onWriteClick={trackReviewClick} reviewId={reviewId} />
  } else {
    return (
      <Button
        label="Write a review"
        color="primary"
        className={className}
        onClick={() => {
          trackReviewClick()
          setReturnToPath(`/brands/${brandSlug}/review`)
          authenticationService.send({
            type: 'SHOW_MODAL',
            mode: 'register',
            analyticsContext: 'write-review',
            copyContext: 'reviews',
            onSigninSuccess: () => {
              returnToOrRedirect(`/brands/${brandSlug}/review`)
            }
          })
        }}
      />
    )
  }
}
